let mp = $('.moving-products');

if (mp.length) {
  $(window).on('scroll', () => {
    let sc = mp.find('.scroll-content');
    let top = $(window).scrollTop();
    let topPosition = mp.offset().top;
    let newPosition = top - topPosition + 5;

    if (top >= topPosition) {
      sc.css({
        top: newPosition
      });
    } else {
      sc.css({
        top: 0
      });
    }

    let container = mp.parent();

    if (container.height() < (sc.position().top + sc.height())) {
      sc.css({
        top: container.height() - sc.height() + 10
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/js/components/moving-products.js